import { type JSX } from "react";
import {
  type ColumnDef,
  type OnChangeFn,
  type RowSelectionState,
} from "@tanstack/react-table";

import { type ProspectResponse } from "@vega-api/generated/types/prospectResponse";
import { CardVariant } from "@vega-core/components/Cards/EmptyCard/EmptyCard";
import { CoreTable } from "@vega-core/components/Table/CoreTable/CoreTable";
import { m } from "@vega-core/paraglide/messages";

type SalesforceProspectsTableProps = {
  data: ProspectResponse[];
  isLoading: boolean;
  paginationElement: JSX.Element | null;
  selectedRows?: RowSelectionState;
  onRowSelectionChange?: OnChangeFn<RowSelectionState>;
  hasActiveFilters?: boolean;
};

export const SalesforceProspectsTable = ({
  data,
  isLoading,
  paginationElement,
  onRowSelectionChange,
  selectedRows,
}: SalesforceProspectsTableProps) => {
  const columns: ColumnDef<ProspectResponse>[] = [
    {
      accessorKey: "limitedPartnerName",
      header: m.coInvestments_limitedPartner(),
      cell: ({ row }) => (
        <span className="body-base-medium">
          {row.original.limitedPartnerName}
        </span>
      ),
    },
    {
      accessorKey: "limitedPartnerRegion",
      cell: ({ row }) => (
        <span className="body-base-regular">
          {row.original.limitedPartnerRegion}
        </span>
      ),
      header: m.formFields_region(),
    },
  ];

  return (
    <CoreTable
      columns={columns}
      compactCheckbox
      data={data}
      dataTestId="salesforce-prospects-table"
      disableResetSelectionOnDataChange
      emptyState={{
        title: m.coInvestments_findProspectsFromSalesforce_noProspectsFound(),
        variant: CardVariant.NoResults,
      }}
      enableRowSelection
      getRowId={(row) => row.limitedPartnerId}
      isLoading={isLoading}
      onRowSelectionChange={onRowSelectionChange}
      paginationElement={paginationElement}
      selectOnRowClick
      selectedRows={selectedRows}
    />
  );
};
